import $ from 'cash-dom'

const updateSectionImages = () => {
  const $colorOptions = $(
    '[data-component="color-swatches"] input[type="radio"]'
  )
  const $selectedOption = $(
    '[data-component="color-swatches"] input[type="radio"]:checked'
  )

  const getColorInSrcAttributes = (src, type) => {
    if (!src) return ''
    const splitFlash = src.split('/')
    const imageName = splitFlash[splitFlash.length - 1].split('.')[0]
    if (!imageName) return ''
    const imageNameElements = imageName.split('-')
    return imageNameElements[
      imageNameElements.length - (type === 'comparison-column' ? 2 : 1)
    ]
  }

  const updateImageAttribute = ($img, attribute, selectedColor, type) => {
    let value = $img.attr(attribute)
    const currentColor = getColorInSrcAttributes(value, type)
    value = value?.replaceAll(currentColor, selectedColor.replaceAll(' ', '_'))
    $img.attr(attribute, value)
  }

  const updateImageSources = (color, element) => {
    if (color) {
      const $comparisonColumnParent = $(element)
        .parents('[data-section="comparison-column"]')
        .first()
      const $learnMoreContentParent = $(element)
        .parents('[data-section="learn-more-content"]')
        .first()

      const $image = (
        $comparisonColumnParent.length > 0
          ? $comparisonColumnParent
          : $learnMoreContentParent
      )
        .find('.color-img')
        .first()

      const selectedColor = color?.toLowerCase()

      updateImageAttribute(
        $image,
        'src',
        selectedColor,
        $comparisonColumnParent.length > 0
          ? 'comparison-column'
          : 'learn-more-content'
      )
      updateImageAttribute(
        $image,
        'srcset',
        selectedColor,
        $comparisonColumnParent.length > 0
          ? 'comparison-column'
          : 'learn-more-content'
      )
    }
  }

  if ($selectedOption.length) {
    updateImageSources($selectedOption.val())
  }

  $colorOptions.each((index, element) => {
    $(element).on('change', function () {
      if ($(this).is(':checked')) {
        updateImageSources($(this).val(), $(element))
      }
    })
  })
}

const updateColorSelectionSectionHeight = () => {
  const $colorOptions = $('[data-element="comparison-color-swatches"]')
  if ($colorOptions.length === 0) return

  $colorOptions.css('height', 'auto')

  let max = 0
  $colorOptions.each(function () {
    const h = $(this).height() // content height (excludes padding/border)
    if (h > max) max = h
  })

  if (max > 0) {
    $colorOptions.height(max)
  }
}

if (
  $('[data-section="whats-included"]').length ||
  $('[data-section="learn-more"]').length ||
  $('[data-section="comparison-column"]').length
) {
  updateSectionImages()
  updateColorSelectionSectionHeight()
}

export { updateSectionImages }
